import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function DikkatSuresiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['dikkat-suresi-testi']} />;
}
